<div class="flex-row center-row" style="margin-top: 15px">
  <!-- Left Column -->
  <div class="flex-col bordered-container">
    <div class="flex-col rows-container">
      <div class="flex-row row-display">
        <label class="stock-label">Rek</label>
        <label>{{ sign.defaultLocation?.rack }}</label>
      </div>
      <div class="flex-row row-display">
        <label class="stock-label">Schap</label>
        <label>{{ sign.defaultLocation?.shelf }}</label>
      </div>
      <div class="flex-row row-display">
        <label class="stock-label">Vak</label>
        <label>{{ sign.defaultLocation?.compartment }}</label>
      </div>
      <div class="row-display">
        <!-- Empty row -->
      </div>
      <div class="flex-row row-display">
        <label class="stock-label">Minimum Voorraad</label>
        <label class="red-text">{{ sign.minimumStock }}</label>
      </div>

      <div class="flex-row row-display field-input">
        <label class="stock-label">Hoe recuperen </label>

        <mat-form-field appearance="outline">
          <mat-select
            matInput
            [(ngModel)]="sign.recupMethod"
            [compareWith]="compareRecupMethod"
            (ngModelChange)="setRecupMethod()"
          >
            <mat-option
              *ngFor="let option of RecupMethodChoiceArray"
              [value]="option"
            >
              {{ option ? option.label : 'Niet ingevuld' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="flex-col rows-container mt-auto">
      <div class="cluster-container mb-10">
        <div class="flex-row row-display">
          <div>
            <label class="stock-label">Offerte verzonden</label>
          </div>
          <div class="flex-row editable-amount">
            <mat-checkbox
              [(ngModel)]="sign.stockOfferSent"
              (ngModelChange)="setStockOfferSent()"
            ></mat-checkbox>
          </div>
        </div>
        <div class="flex-row row-display">
          <div>
            <label class="stock-label">Offerte</label>
          </div>
          <div class="flex-row editable-amount">
            <label>{{ inOffer?.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editInOffer()"
            ></mat-icon>
          </div>
        </div>
        <div style="margin-top: -15px; margin-bottom: 15px">
          <span *ngIf="inOffer.offerDate">
            {{ inOffer.offerDate | date : 'dd/MM/yyyy' }}
            <ng-container *ngIf="inOffer.offerRequester">
              &mdash; {{ inOffer.offerRequester.firstName }}
              {{ inOffer.offerRequester.lastName }}
            </ng-container>
          </span>
        </div>

        <div class="flex-row row-display">
          <button
            type="button"
            mat-button
            class="production-stock-to-physical-stock-button"
            [disabled]="inOffer?.amount <= 0"
            (click)="transferOfferStockToProduction()"
          >
            Naar productie
          </button>
        </div>
      </div>

      <div class="cluster-container">
        <div class="flex-row row-display">
          <div>
            <label class="stock-label">Bestelling</label>
          </div>
          <div class="flex-row editable-amount">
            <label>{{ directOrder?.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editDirectOrder()"
            ></mat-icon>
          </div>
        </div>
        <div style="margin-top: -15px; margin-bottom: 15px">
          <span *ngIf="directOrder.directOrderDate">
            {{ directOrder.directOrderDate | date : 'dd/MM/yyyy' }}
            <ng-container *ngIf="directOrder.directOrderRequester">
              &mdash; {{ directOrder.directOrderRequester.firstName }}
              {{ directOrder.directOrderRequester.lastName }}
            </ng-container>
          </span>
        </div>

        <div class="flex-row row-display">
          <button
            type="button"
            mat-button
            class="production-stock-to-physical-stock-button"
            [disabled]="directOrder?.amount <= 0"
            (click)="transferDirectOrderToProduction()"
          >
            Naar productie
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Middle Column -->
  <div class="flex-col bordered-container">
    <ng-container *ngIf="isFetching; else stockOverview">
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </ng-container>

    <ng-template #stockOverview>
      <div class="flex-col rows-container">
        <div class="flex-row row-display">
          <div class="flex-row">
            <label class="stock-label">Totaal Voorraad</label>
            <mat-icon
              class="red-text"
              *ngIf="
                unsupportedRemainderStock &&
                unsupportedRemainderStock.length > 0
              "
              [matTooltip]="
                'Er is voorraad gedetecteerd die niet ondersteund wordt door deze weergave. Neem contact op met de developers'
              "
              >warning</mat-icon
            >
          </div>
          <label>{{ stockAmountGrandTotal }}</label>
        </div>

        <div class="flex-row row-display">
          <div class="flex-row">
            <label class="stock-label">Magazijn Voorraad</label>
            <mat-icon
              class="red-text"
              *ngIf="
                unsupportedPhysicalStock && unsupportedPhysicalStock.length > 0
              "
              [matTooltip]="
                'Er is voorraad gedetecteerd die niet ondersteund wordt door deze weergave. Neem contact op met de developers'
              "
              >warning</mat-icon
            >
          </div>
          <label class="green-text">{{ stockAmountWarehouseTotal }}</label>
        </div>

        <div class="flex-row row-display indented">
          <label class="stock-label">- Duoprop</label>
          <div class="flex-row duoprop-amounts">
            <div class="flex-row editable-amount">
              <div class="annotated-amount">
                <label class="annotation">Dak</label>
                <label class="green-text">{{
                  duopropRoof ? duopropRoof.amount : 0
                }}</label>
              </div>
              <mat-icon
                class="clickable"
                svgIcon="edit"
                [matTooltip]="'Verhoog/verlaag'"
                (click)="editDuopropRoof()"
              ></mat-icon>
            </div>
            <div class="flex-row editable-amount">
              <div class="annotated-amount">
                <label class="annotation">Rek</label>
                <label class="green-text">{{
                  duopropDefault ? duopropDefault.amount : 0
                }}</label>
              </div>
              <mat-icon
                class="clickable amount-edit-icon"
                svgIcon="edit"
                [matTooltip]="'Verhoog/verlaag'"
                (click)="editDuopropDefaultLocation()"
              ></mat-icon>
            </div>
          </div>
        </div>

        <div
          *ngIf="!sign.withoutStock"
          class="flex-row row-display field-input indented"
        >
          <label class="stock-label mb-4"
            ><span class="hidden">-</span> Locatie dak</label
          >
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              [(ngModel)]="roofLocation"
              (ngModelChange)="roofLocationEdited()"
            />
          </mat-form-field>
        </div>
        <br />

        <div class="flex-row row-display indented">
          <label class="stock-label">- Op kader</label>
          <div class="flex-row editable-amount">
            <label class="green-text">{{ frameCorner.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editOnFrame()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display indented">
          <label class="stock-label">- Lopende bestelling</label>
          <div class="flex-row editable-amount">
            <label class="red-text">{{ pending.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editPending()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display">
          <label class="stock-label">Geplaatste borden</label>
          <div class="flex-row editable-amount">
            <label>{{ placed.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editPlaced()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display indented">
          <label class="stock-label">- Plaatsing bezig</label>
          <div class="flex-row editable-amount">
            <label>{{ placementInProgress.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editPlacementInProgress()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display">
          <label class="stock-label">Nog af te breken intern</label>
          <div class="flex-row editable-amount">
            <label>{{ toDisassemble.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editToDisassemble()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display">
          <label class="stock-label">Uitgestelde borden</label>
          <div class="flex-row editable-amount">
            <label>{{ deferred.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editDeferred()"
            ></mat-icon>
          </div>
        </div>

        <div class="flex-row row-display">
          <label class="stock-label">In productie</label>
          <div class="flex-row editable-amount">
            <label>{{ inProduction.amount }}</label>
            <mat-icon
              class="clickable"
              svgIcon="edit"
              [matTooltip]="'Verhoog/verlaag'"
              (click)="editInProduction()"
            ></mat-icon>
          </div>
        </div>
        <div class="flex-row row-display">
          <button
            type="button"
            mat-button
            class="production-stock-to-physical-stock-button"
            [disabled]="inProduction?.amount <= 0"
            (click)="openProductionStockToPhysicalStockModal()"
          >
            In productie klaar
          </button>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Right Column - no content yet -->
</div>

<!-- Below is the old code for the table based views, keeping it for now because I expect we'll need it later -->

<!-- <div class="flex-row total-container">
    <label class="total-label">Totale voorraad</label>
    <label class="total-amount">{{ stockAmountGrandTotal }}</label>
  </div>

  <div class="flex-row total-container">
    <label class="total-label">Magazijn voorraad</label>
    <label class="total-amount">{{ stockAmountPhysicalTotal }}</label>
  </div>

  <div class="flex-row total-container">
    <label class="total-label">Lopende bestellingen</label>
    <label class="total-amount">{{ stockAmountPending }}</label>
  </div>

  <h3>Magazijn</h3>

  <ng-container *ngIf="sign.defaultLocation && sign.defaultLocation.rack">
    Standaard locatie {{ sign.defaultLocation.rack }} :
    {{ sign.defaultLocation.shelf }} : {{ sign.defaultLocation.compartment }}
  </ng-container>

  <div class="flex-table stock-table" style="margin-top: 15px;">
    <div class="flex-header-row">
      <div class="flex-3 flex-table-cell">Locatie</div>
      <div class="flex-3 flex-table-cell">Op kader</div>
      <div class="flex-1 flex-table-cell">Aantal</div>
      <div class="flex-1 flex-table-cell"></div>
    </div>
    <div *ngFor="let item of physicalStock" class="flex-table-row">
      <div class="flex-3 flex-table-cell">
        {{ item.location.rack }} : {{ item.location.shelf }} :
        {{ item.location.compartment }}
      </div>
      <div class="flex-3 flex-table-cell">
        <ng-container *ngIf="item.boardType; else duoProp">
          {{ item.boardType?.label }} ({{ item.frame.label }})
        </ng-container>
        <ng-template #duoProp>
          Nee
        </ng-template>
      </div>
      <div class="flex-1 flex-table-cell">{{ item.amount }}</div>
      <div class="flex-1 flex-table-cell">
        <div
          class="pull-left clickable"
          [matTooltip]="'Verhoog/verlaag'"
          (click)="editStockItem(item)"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="physicalStock.length === 0" class="flex-table-row">
      Niet in voorraad
    </div>
  </div>

  <h3>Geplaatste borden</h3>

  <div class="flex-table stock-table" style="margin-top: 15px;">
    <div class="flex-header-row">
      <div class="flex-3 flex-table-cell">Op kader</div>
      <div class="flex-1 flex-table-cell">Aantal</div>
      <div class="flex-1 flex-table-cell"></div>
    </div>
    <div *ngFor="let item of placedStock" class="flex-table-row">
      <div class="flex-3 flex-table-cell">
        <ng-container *ngIf="item.boardType; else duoProp">
          {{ item.boardType?.label }} ({{ item.frame.label }})
        </ng-container>
        <ng-template #duoProp>
          Nee
        </ng-template>
      </div>
      <div class="flex-1 flex-table-cell">{{ item.amount }}</div>
      <div class="flex-1 flex-table-cell">
        <div
          class="pull-left clickable"
          [matTooltip]="'Verhoog/verlaag'"
          (click)="editStockItem(item)"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </div>
      </div>
    </div>
    <div *ngIf="placedStock.length === 0" class="flex-table-row">
      Niet in voorraad
    </div>
  </div>

  <h3>Intern te demonteren</h3>

  Gelijkaardig aan 'Geplaatste borden'

  <h3>Uitgestelde borden</h3>

  Gelijkaardig aan 'Geplaatste borden'

  <h3>In productie</h3>

  Gelijkaardig aan 'Geplaatste borden'

  <br />

  <div
    class="pull-left clickable"
    [matTooltip]="'Stock aanpassen'"
    (click)="startEditingStock()"
  >
    <mat-icon svgIcon="edit"></mat-icon>
  </div> -->
